/** @format */

import React, { Component } from "react";
import * as qs from "query-string";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import debounce from "lodash.debounce";
import { ApiRoutes, AppRoutes, pagesOption } from "../../../config";
import { ApiHelper } from "../../../helpers";
import { ListClientComponent } from "../../components/clients";
import { GridClientComponent } from "../../components/clients";
import { CategoryCard } from "../../components/loader/Resusable/CategoryCard";
import Pagination from "../../components/pagination";
import { Breadcrumbs } from "../../components/partial/Breadcrumbs";
import SweetAlertComponent from "../../components/sweetAlertComponent";
import { FilterComponent } from "../../components/filters";
import { SearchFilter } from "../../components/filters/searchFilter";
import pageDropdownIcon from "../../../assets/img/tag-bd.svg";
import gridActive from "../../../assets/img/grid-active.svg";
import ListNoActive from "../../../assets/img/list-noactive.svg";
import gridNoActive from "../../../assets/img/grid-noactive.svg";
import ListActive from "../../../assets/img/list-active.svg";
import noData from "../../../assets/img/no-data.png";
import filterarrowIcon from "../../../assets/img/filter-arrow.svg";
import { Link } from "react-router-dom";
import "./manage-clients.css";

class ManageClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: [],
      errors: null,
      isLoading: false,
      isAdding: false,
      totalRecords: 0,
      currentPage: 1,
      limit: 11,
      sortBy: "all",
      order: "desc",
      search: "",
      isFormOpen: false,
      isUpdating: false,
      activeId: "",
      viewMode: "grid",
    };
    this.emitSearch = debounce(this.onSearch, 200);
  }
  componentDidMount = () => {
    this.handleQueryParams();
  };
  handleQueryParams = () => {
    const {
      location: { search },
    } = this.props;

    const query = qs.parse(search);
    this.setState(
      {
        currentPage: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 10,
        search: query.search || "",
        sortBy: query.sort || "all",
        order: query.order ? query.order : "desc",
        viewMode: query.view || "grid",
      },
      () => this.fetchClientReq()
    );
  };

  componentDidUpdate = ({ location: { search: prevSearch } }) => {
    const {
      location: { search },
    } = this.props;
    if (prevSearch !== search) {
      this.handleQueryParams();
    }
  };
  onPageChanged = (page) => {
    const { currentPage } = this.state;
    if (page !== currentPage) {
      const {
        location: { search, pathname },
      } = this.props;
      const query = qs.parse(search);
      this.props.history.push(
        [pathname, qs.stringify({ ...query, page })].join("?")
      );
    }
  };

  onLimitChange = (limit) => {
    const {
      location: { search, pathname },
    } = this.props;
    const query = qs.parse(search);
    this.props.history.push(
      [pathname, qs.stringify({ ...query, page: 1, limit })].join("?")
    );
  };

  fetchClientReq = async (loading = true) => {
    const { currentPage, limit, sortBy, order, search } = this.state;
    let skip = limit * (currentPage - 1);
    let data = {
      skip,
      limit,
      sortBy,
      search,
      order,
    };
    this.setState({
      isLoading: loading,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.GET_CLIENTS.service,
      ApiRoutes.GET_CLIENTS.url,
      ApiRoutes.GET_CLIENTS.method,
      ApiRoutes.GET_CLIENTS.authenticate,
      data,
      undefined
    );
    this.setState({
      isLoading: false,
      isUpdating: false,
      activeId: "",
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      const {
        data: { clients, totalRecords },
      } = response.data;
      this.setState({
        clients,
        totalRecords,
      });
    }
  };

  viewHandler = (id) => {
    const {
      props: {
        location: { search },
      },
    } = this;
    this.props.history.push({
      pathname: AppRoutes.VIEW_CLIENT.replace(":id", id),
      state: {
        search,
      },
    });
  };

  // To handle search on typing
  handleSearch = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value });
    event.persist();
    this.emitSearch();
  };

  onSearch = () => {
    const { search } = this.state;
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    params.search = search;
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };
  setFilter = (sortBy, order) => {
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    if (sortBy) {
      params.sort = sortBy;
    }
    if (order) {
      params.order = order;
    } else {
      params.order =
        sortBy === "brandName" || sortBy === "companyName" || sortBy === "email"
          ? "asc"
          : "desc";
    }

    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  blockClient = async (id) => {
    const { value } = await SweetAlertComponent({
      // title: 'Are you sure?',
      text: `Are you sure, you want to block this client?`,
    });
    if (!value) {
      return;
    }
    this.setState({
      isUpdating: true,
      activeId: id,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.BLOCK_USER.service,
      ApiRoutes.BLOCK_USER.url.replace(":id", id),
      ApiRoutes.BLOCK_USER.method,
      ApiRoutes.BLOCK_USER.authenticate,
      undefined,
      undefined
    );
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      await this.fetchClientReq(false);
      toast.success(response.messages[0]);
    }
  };
  unBlockClient = async (id) => {
    const { value } = await SweetAlertComponent({
      // title: 'Are you sure?',
      text: `Are you sure, you want to unblock this client?`,
    });
    if (!value) {
      return;
    }
    this.setState({
      isUpdating: true,
      activeId: id,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.UNBLOCK_USER.service,
      ApiRoutes.UNBLOCK_USER.url.replace(":id", id),
      ApiRoutes.UNBLOCK_USER.method,
      ApiRoutes.UNBLOCK_USER.authenticate,
      undefined,
      undefined
    );
    this.setState({
      isLoading: false,
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      await this.fetchClientReq(false);
      toast.success(response.messages[0]);
    }
  };

  render() {
    const {
      clients,
      viewMode,
      isLoading,
      totalRecords,
      currentPage,
      limit,
      sortBy,
      order,
      search,
      isUpdating,
      activeId,
    } = this.state;
    const {
      props: {
        location: { pathname },
      },
    } = this;

    const filtersOption = [
      { label: "All", value: "all" },
      { label: "Company", value: "companyName" },
      { label: "Email", value: "email" },
      { label: "Date", value: "createdAt" },
    ];

    return (
      <div className="container-fluid fluid-pd-2">
        <h1 className="h3-head-mob d-md-none">Manage Clients</h1>
        <Breadcrumbs pathname={pathname} />
        <div className="card card-pagination card-main">
          <div className="card-header  py-7550  align-items-center justify-content-between">
            <div className="row">
              <div className="col-md-3 head-col-lg">
                <h6 className="font-book ">Clients Listing</h6>
              </div>

              <div className="col-md-10  mob-filter-data">
                <Dropdown className="no-arrow dp-right">
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                    className={"filter-btn-mob"}
                  >
                    {" "}
                    <span className="staff-value">
                      {
                        (
                          filtersOption.filter(
                            (filter) => filter.value === limit
                          )[0] || {}
                        ).label
                      }
                    </span>{" "}
                    <img src={pageDropdownIcon} alt="" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="shadow dropdown-menu-right dropdown-opt-mob mob-drp">
                    {filtersOption.map(({ label, value }, index) => (
                      <Dropdown.Item
                        as="div"
                        key={index}
                        onClick={() => this.setFilter(value)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div className="dropdown no-arrow dp-right">
                  <button
                    className="btn btn-secondary filter-btn-mob"
                    id="statusMenuLink-mob"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src="img/tag-search-bd.svg" alt="" />
                  </button>
                </div>
              </div>

              <div className="col-md-9 filter-col-lg">
                <div className="dp-right">
                  <Link
                    className="btn btn-primary add-btn add-wd-1024"
                    to={AppRoutes.MANAGE_CLIENTS_REQUESTS}
                  >
                    {" "}
                    View Requests
                  </Link>
                </div>
                <FilterComponent
                  options={filtersOption}
                  selectedFilter={sortBy}
                  onFilterChange={this.setFilter}
                />

                <SearchFilter
                  id={"sm-search-filter"}
                  placeholder={"Search by Store and Company name"}
                  search={search}
                  onChange={this.handleSearch}
                />

                <div className="dp-right">
                  <Link
                    className=" icon-btn"
                    to={`${AppRoutes.MANAGE_CLIENTS}?view=list`}
                  >
                    <img
                      src={viewMode === "list" ? ListActive : ListNoActive}
                      alt=""
                    />
                  </Link>
                  <Link
                    className=" icon-btn"
                    to={`${AppRoutes.MANAGE_CLIENTS}?view=grid`}
                  >
                    <img
                      src={viewMode === "grid" ? gridActive : gridNoActive}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {viewMode === "grid" ? (
            <div className="card-body card-grid row-grid-fixed">
              <div className="row ">
                {isLoading ? (
                  <CategoryCard />
                ) : clients && clients.length ? (
                  <>
                    <GridClientComponent
                      clients={clients}
                      isUpdating={isUpdating}
                      activeId={activeId}
                      blockClient={this.blockClient}
                      unBlockClient={this.unBlockClient}
                      viewHandler={this.viewHandler}
                    />
                  </>
                ) : (
                  <div className="col-md-12 col-vd-nodata">
                    <img src={noData} alt="" />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <ListClientComponent
              clients={clients}
              isLoading={isLoading}
              isUpdating={isUpdating}
              activeId={activeId}
              viewHandler={this.viewHandler}
              blockClient={this.blockClient}
              unBlockClient={this.unBlockClient}
              setFilter={this.setFilter}
              order={order}
              sortBy={sortBy}
            />
          )}
        </div>
        <div className="footer-pg custom-align">
          {!isLoading ? (
            <div className="float-left mt-2">
              <p className="page-desc-left">
                Total: <span className="bold-black">{totalRecords}</span>
              </p>
            </div>
          ) : null}
          <div className="float-right mt-2">
            <p className="page-desc ml-2 float-right">Table View</p>

            <Dropdown className="no-arrow dp-right ml-2">
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className={"filter-btn"}
              >
                {" "}
                <span className="staff-value">
                  {
                    (
                      pagesOption.filter(
                        (filter) => filter.value === limit
                      )[0] || {}
                    ).label
                  }
                </span>{" "}
                <img src={filterarrowIcon} alt="" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="shadow top-open dropdown-menu-right dropdown-staff">
                {pagesOption.map(({ label, value }, index) => (
                  <Dropdown.Item
                    as="div"
                    key={index}
                    onClick={() => this.onLimitChange(value)}
                  >
                    {label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {!isLoading && totalRecords > limit ? (
              <div className="float-right">
                <Pagination
                  totalRecords={totalRecords}
                  currentPage={currentPage}
                  pageLimit={limit}
                  onPageChanged={this.onPageChanged}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default ManageClient;
